import React from 'react';
import AudioRecorder from '../../utils/test/audioAnalyser';
import IosAudioRecorder from '../../utils/test/iosAudioRecorder';
import { isIos } from '../../../../utils/commonFunctions';
import { setResetCounter } from '../../../../redux/testPage/testPage.actions';
import { connect } from 'react-redux';
import RecordInstruction from '../../utils/test/recordInstruction';

const SpeechRecorder = ({
	isMicPermitted,
	rightSectionProps: { questionId, resetCounter },
	setResetCounter,
	rightSectionProps,
}) => {
	const updateCounter = () => {
		resetCounter = resetCounter - 1;
		localStorage.setItem('resetCounter', resetCounter);
		setResetCounter({
			rightSectionProps: { ...rightSectionProps, resetCounter },
		});

		if (!(resetCounter > 0)) {
			document
				.getElementsByClassName('icon-start_cloze')[0]
				.classList.add('disabledElement');
			let el = document.getElementById('resetButton');
			if (!!el) {
				el.style.background = '#959595';
			}
			let elCloze = document.getElementById('resetClozeButton');
			if (!!elCloze) {
				elCloze.style.background = '#959595';
			}
		}
	};

	return (
		<div>
			<div className="clearfix step-toptions-wrapper" id="div_90681">
				<div className="speaking-question">
					{isIos() ? (
						<IosAudioRecorder
							key={questionId}
							error_message={'Please answer this question'}
							updateCounter={updateCounter}
							index={0}
						/>
					) : (
						<AudioRecorder
							key={questionId}
							error_message={'Please answer this question'}
							updateCounter={updateCounter}
							index={0}
						/>
					)}
					<RecordInstruction resetCounter={resetCounter} />

					<input
						type="hidden"
						name="resetCounter"
						id="resetCounter"
						value={resetCounter}
					/>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		rightSectionProps,
		questionNo,
		isMicPermitted,
	} = state.rootReducer.testPageDetails;

	return {
		rightSectionProps,
		questionNo,
		isMicPermitted,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setResetCounter: (val) => dispatch(setResetCounter(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SpeechRecorder);
